<template>
  <div>
    <NavBar></NavBar>
    <button v-show="showBtnBack" class="btn btn-danger float-end mt-2 me-2" @click.prevent="goBack()"><svg
        xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-left-circle"
        viewBox="0 0 16 16">
        <path fill-rule="evenodd"
          d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-4.5-.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5z" />
      </svg> Materias P. Procesadas</button>
    <h2 class="mt-3 mb-3" v-show="showTitle"><strong><i> {{ selectedFamilyName }} </i></strong> para {{
      this.rawMatFamilyName }}</h2>
    <h2 class="mt-3 mb-3" v-show="showTitleP">Grupo de formas para <strong>{{ $store.getters.getRawMatDescription
    }}</strong></h2>
    <FormCards @sendFamilyInfo="getFamilyInfo" v-if="selectedFamilyId === null"></FormCards>
    <ImagesByFamily :useFamilyId="selectedFamilyId" v-if="selectedFamilyId !== null" @goBack="goBackToFormCards">
    </ImagesByFamily>
  </div>
</template>

<script>
import NavBar from "@/components/GeneralComponents/NavBarComponent.vue"
import FormCards from "@/components/GeneralComponents/FormsGroupsByFamilyComponent.vue"
import ImagesByFamily from "@/components/GeneralComponents/ImagesByFamilyComponent.vue"

export default {
  data() {
    return {
      selectedFamilyId: null,
      selectedFamilyName: null,
      showTitle: false,
      showTitleP: true,
      rawMatFamilyName: "",
      showBtnBack: true,
    }
  },
  methods: {
    getFamilyInfo(data) {
      // console.log(data);
      this.selectedFamilyId = data[0];
      // console.log(this.selectedFamilyId);
      this.selectedFamilyName = data[1];
      this.showBtnBack = false;
      this.showTitle = true;
      this.showTitleP = false;
    },
    goBackToFormCards() {
      this.selectedFamilyId = null;
      this.showBtnBack = true;
      this.showTitle = false;
      this.showTitleP = true;
    },
    goBack() {
      this.$router.push("/Families")
    }
  },
  mounted() {
    this.rawMatFamilyName = this.$store.getters.getRawMatFamily;
    //console.log(this.rawMatFamilyName);
    switch (this.rawMatFamilyName) {
      case "ACERO_CARBONO":
        this.rawMatFamilyName = "Láminas metálicas HR / CR / Alfajor"
        break;
      case "INOXIDABLE":
        this.rawMatFamilyName = "Lámina metálica Inoxidable"
        break;
      case "ALUMINIO":
        this.rawMatFamilyName = "Lámina metálica en Aluminio"
        break;
      case "ANTIDESGASTE":
        this.rawMatFamilyName = "Lámina metálica Antidesgaste"
        break;
      case "CANAL_U":
        this.rawMatFamilyName = "Perfil estructural canal en U";
        break;
      case "VIGA_I":
        this.rawMatFamilyName = "Perfil estructural viga en I";
        break;
      case "VIGA_H":
        this.rawMatFamilyName = "Perfil estructural viga en H";
        break;
      case "ANGULO":
        this.rawMatFamilyName = "Perfil estructural tipo ángulo (L)";
        break;
      case "ESTRUCTURAL":
        this.rawMatFamilyName = "Tubería tipo estructural";
        break;
      case "MUEBLE":
        this.rawMatFamilyName = "Tubería tipo mueble";
        break;
      default:
        this.rawMatFamilyName = "";
        break;
    }
  },
  components: {
    NavBar,
    FormCards,
    ImagesByFamily,
  }
}
</script>
<style scoped></style>